import { render, staticRenderFns } from "./PartnerOfTheWeek.vue?vue&type=template&id=3426ad1a&scoped=true"
import script from "./PartnerOfTheWeek.vue?vue&type=script&lang=js"
export * from "./PartnerOfTheWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3426ad1a",
  null
  
)

export default component.exports